import { ActionTypes, WorkOrderSettingActions } from './work-order-settings.actions';
import { WorkOrderSettingState } from './work-order-settings.model';

export const workOrderSettingState: WorkOrderSettingState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getWorkOrderSettingLoading: false,
  getWorkOrderSettingLoaded: false,
  workOrderSetting: null,
  addWorkOrderSettingLoading: false,
  addWorkOrderSettingLoaded: false,
  editWorkOrderSettingLoading: false,
  editWorkOrderSettingLoaded: false,
  deleteWorkOrderSettingsLoading: false,
  deleteWorkOrderSettingsLoaded: false,
  changeActivitiesDataLoading: false,
  changeActivitiesDataLoaded: false,
  changeActivitiesData: [],
  heartbeatSettingsDataLoading: false,
  heartbeatSettingsDataLoaded: false,
  heartbeatSettingsData: [],
  productsDataLoading: false,
  productsDataLoaded: false,
  productsData: [],
};

export function workOrderSettingReducer(
  state: WorkOrderSettingState = workOrderSettingState,
  action: WorkOrderSettingActions,
): WorkOrderSettingState {
  switch (action.type) {
    case ActionTypes.WORK_ORDER_SETTINGS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.WORK_ORDER_SETTINGS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_WORK_ORDER_SETTING:
      return {
        ...state,
        getWorkOrderSettingLoading: true,
        getWorkOrderSettingLoaded: false,
      };
    case ActionTypes.GET_WORK_ORDER_SETTING_COMPLETED:
      return {
        ...state,
        workOrderSetting: action.payload.data,
        getWorkOrderSettingLoading: false,
        getWorkOrderSettingLoaded: true,
      };
    case ActionTypes.ADD_WORK_ORDER_SETTING:
      return {
        ...state,
        addWorkOrderSettingLoading: true,
        addWorkOrderSettingLoaded: false,
      };
    case ActionTypes.ADD_WORK_ORDER_SETTING_COMPLETED:
      return {
        ...state,
        addWorkOrderSettingLoading: false,
        addWorkOrderSettingLoaded: true,
      };
    case ActionTypes.EDIT_WORK_ORDER_SETTING:
      return {
        ...state,
        editWorkOrderSettingLoading: true,
        editWorkOrderSettingLoaded: false,
      };
    case ActionTypes.EDIT_WORK_ORDER_SETTING_COMPLETED:
      return {
        ...state,
        editWorkOrderSettingLoading: false,
        editWorkOrderSettingLoaded: true,
      };
    case ActionTypes.DELETE_WORK_ORDER_SETTINGS:
      return {
        ...state,
        deleteWorkOrderSettingsLoading: true,
        deleteWorkOrderSettingsLoaded: false,
      };
    case ActionTypes.DELETE_WORK_ORDER_SETTINGS_COMPLETED:
      return {
        ...state,
        deleteWorkOrderSettingsLoading: false,
        deleteWorkOrderSettingsLoaded: true,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        changeActivitiesDataLoading: true,
        changeActivitiesDataLoaded: false,
      };
    case ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        changeActivitiesData: action.payload,
        changeActivitiesDataLoading: false,
        changeActivitiesDataLoaded: true,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_LOADING:
      return {
        ...state,
        heartbeatSettingsDataLoading: true,
        heartbeatSettingsDataLoaded: false,
      };
    case ActionTypes.HEARTBEAT_SETTINGS_DATA_COMPLETED:
      return {
        ...state,
        heartbeatSettingsData: action.payload,
        heartbeatSettingsDataLoading: false,
        heartbeatSettingsDataLoaded: true,
      };
    case ActionTypes.PRODUCTS_DATA_LOADING:
      return {
        ...state,
        productsDataLoading: true,
        productsDataLoaded: false,
      };
    case ActionTypes.PRODUCTS_DATA_COMPLETED:
      return {
        ...state,
        productsData: action.payload,
        productsDataLoading: false,
        productsDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
